import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css'
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
// import logo from '../Assets/Images/logo.png'
import logo from '../Assets/Images/Gravinora.png'
import TermsConditions from '../components/auth/register/TermsConditions';



function Footer() {
    const navigate = useNavigate();
    const [showTermsModal, setShowTermsModal] = useState(false);
    const handleTermsClick = () => {
        setShowTermsModal(true);
    };
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <footer className="footer text-light p-4">
            <div className='d-flex flex-wrap align-items-center justify-content-center '>
                <div className='mb-1 col-lg-2 col-sm-12 col-md-2 d-flex justify-content-center align-items-center'>

                    <img
                        src={require('../Assets/Images/Gravinora.png')}
                        alt="GRAVINORA Logo"
                        style={{
                            height: '50px',
                            width: '139px',

                            objectFit: 'cover',
                            backgroundColor: '#fff',
                            padding: '2px',
                        }}
                    />
                    {/* <div
                        style={{
                            width: '50px',
                            height: '50px',
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                         <img src={logo} alt="Logo" style={{
                                height: '52px', width: '52px',
                                borderRadius: '50%'
                            }} />
                    </div>
                    <span style={{ fontSize: '18px', fontWeight: 'bold', marginLeft: '10px' }}>VANGUARD</span> */}
                </div>

                <div className='mb-1 col-lg-8  col-sm-12 col-md-8  d-flex align-items-center justify-content-center flex-wrap'>
                    <Link to="/" onClick={scrollToTop} className="text-light d-flex align-items-center link-no-underline p-lg-4 p-sm-3" >
                        Home <AiOutlineArrowRight className="ms-1" />
                    </Link>
                    <Link
                        onClick={(e) => {
                            e.preventDefault();
                            navigate("/#about-section");
                        }}
                        className="text-light d-flex align-items-center link-no-underline p-lg-4  p-sm-3">
                        About Us <AiOutlineArrowRight className="ms-1" />
                    </Link>
                    <Link to="/events" onClick={scrollToTop} className="text-light d-flex align-items-center link-no-underline p-lg-4 p-sm-3">
                        Events <AiOutlineArrowRight className="ms-1" />
                    </Link>
                    <Link to="/blogs" onClick={scrollToTop} className="text-light d-flex align-items-center link-no-underline p-lg-4 p-sm-3">
                        Blogs <AiOutlineArrowRight className="ms-1" />
                    </Link>

                </div>

                <div className='mb-1 col-lg-2  col-md-1 col-sm-12 d-flex justify-content-center'>
                    <Link to="#" className="text-light mx-2"><FaLinkedin size={24} /></Link>
                    <Link to="#" className="text-light mx-2"><FaFacebook size={24} /></Link>
                    <Link to="#" className="text-light mx-2"><FaInstagram size={24} /></Link>
                </div>
            </div>

            <div className='d-flex align-items-center justify-content-center mt-3'>
                <div className=' d-flex flex-wrap align-items-center justify-content-around'>
                    <div className='me-md-5'>
                        <p className="mb-0 text-faint">&copy; 2024 B2B, Inc.</p>
                    </div>
                    <div className='gap-5'>
                        <ul className="list-inline mb-0 d-flex gap-5">
                            {/* <li className="list-inline-item ">
                                <Link 
                                // to="/help" 
                                className="text-faint link-no-underline">
                                    Help
                                </Link>
                            </li> */}
                            <li className="list-inline-item ">
                                <Link
                                    // to="/policy" 
                                    className="text-faint link-no-underline"
                                    onClick={handleTermsClick}
                                >
                                    Privacy policy
                                </Link>
                            </li>
                            <li className="list-inline-item">
                                <Button
                                    variant="link"
                                    className="text-faint p-0 link-no-underline"
                                    onClick={handleTermsClick}
                                >
                                    Terms and Conditions
                                </Button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {/* Terms and Conditions Modal */}
            <Modal
                show={showTermsModal}
                onHide={() => setShowTermsModal(false)}
                size="lg"
                centered
            // scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title>Terms and Conditions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <TermsConditions />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowTermsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </footer>
    )
}

export default Footer;
